<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container">
      <div class="section">
        <div class="columns is-vcentered" v-if="event">
          <div class="column is-2 is-offset-2">
            <img :src="`${event.imgUrl}`" style="width: 150px" />
          </div>
          <div class="column is-6">
            <h1 class="title">{{ event.eventname }}</h1>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div class="flex-card light-bordered light-raised">
            <div class="card-body">
              <h2 class="title">Sign up as Judge</h2>
              <article class="text-danger" v-if="registered">
                You are already registered!
              </article>
              <ValidationObserver v-slot="{ passes }" v-if="!registered">
                <form @submit.prevent="passes(submit)">
                  <div class="columns is-multiline">
                    <div
                      class="column is-12-desktop"
                      v-if="!event.config.hidejudgequalifications"
                    >
                      <div class="control">
                        <b-field label="Qualifications"> </b-field>
                        <div class="block">
                          <div class="columns">
                            <div
                              class="column"
                              v-for="item in qualifications"
                              :key="item"
                            >
                              <b-checkbox
                                v-model="entry.qualifications"
                                :native-value="item"
                              >
                                {{ item }}
                              </b-checkbox>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="column is-12-desktop"
                      v-if="!event.config.hidejudgedays"
                    >
                      <div class="control">
                        <b-field label="Days Available">
                          <div class="block">
                            <div class="columns">
                              <div
                                class="column"
                                v-for="item in daysAvailable"
                                :key="item"
                              >
                                <b-checkbox
                                  v-model="entry.daysAvailable"
                                  :native-value="item"
                                >
                                  {{ item }}
                                </b-checkbox>
                              </div>
                            </div>
                          </div>
                        </b-field>
                      </div>
                    </div>
                    <div class="column is-6-desktop">
                      <div class="control">
                        <SizeSelect
                          rules="required"
                          v-model="entry.shirtsize"
                        ></SizeSelect>
                      </div>
                    </div>
                    <div
                      class="column is-12-desktop"
                      v-if="
                        event && event.legalcontent && event.legalcontent !== ''
                      "
                    >
                      <div
                        v-html="event.legalcontent"
                        class="has-margin-bottom-30 has-padding-10"
                        style="
                          max-height: 400px;
                          overflow-y: auto;
                          border: 1px solid #eee;
                        "
                      ></div>
                      <ValidationProvider
                        name="Terms and Conditions"
                        :rules="'required'"
                        v-slot="{ errors }"
                      >
                        <b-field
                          :type="{ 'is-danger': errors.length > 0 }"
                          :message="errors[0]"
                        >
                          <b-checkbox v-model="entry.terms">
                            Accept event's terms and condition
                          </b-checkbox>
                        </b-field>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="has-text-centered">
                    <div class="is-block has-text-centered">
                      <b-button
                        class="is-primary is-medium"
                        :loading="saving"
                        @click="passes(submit)"
                      >
                        Sign Up
                      </b-button>
                    </div>
                  </div>
                </form>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import JudgeApi from "@/api/judge";
import SizeSelect from "@/components/SizeSelect";
import filters from "@/filters";
export default {
  name: "JudgeSignup",
  mixins: [filters],
  components: {
    SizeSelect,
  },
  data() {
    return {
      registered: false,
      loading: true,
      saving: false,
      entry: {
        qualifications: [],
        daysAvailable: [],
      },
      qualifications: ["CrossFit Level 1", "CrossFit Online Judges Course"],
    };
  },
  async created() {
    this.registered = await JudgeApi.alreadyRegistered(this.$route.params.id);
    await this.getEvent(this.$route.params.id);
    this.loading = false;
  },
  computed: {
    ...mapGetters(["event", "user"]),
    daysAvailable() {
      return this.event && this.event.config && this.event.config.days
        ? this.event.config.days
        : [];
    },
  },
  methods: {
    ...mapActions(["getEvent"]),
    async submit() {
      this.saving = true;
      try {
        await JudgeApi.save(this.$route.params.id, this.entry);
        this.saving = false;
        this.$buefy.toast.open({
          message: "You've signed up successfully!",
          position: "is-top",
          type: "is-success",
        });
        this.$router.push({
          name: "JudgeSignedUp",
          params: {
            id: this.$route.params.id,
          },
        });
      } catch (error) {
        this.saving = false;
        this.$buefy.toast.open({
          message: "Error signing up.",
          position: "is-top",
          type: "is-danger",
        });
      }
    },
  },
};
</script>

<style>
p {
  margin-bottom: 15px;
}
</style>